// extracted by mini-css-extract-plugin
export default {"container":"performanceSummaryTable_container__ItHDp","table":"performanceSummaryTable_table__8DOPX"};